import { h, Transition } from 'vue'
import type { FunctionalComponent } from 'vue'
interface TransitionTypeDetails {
  enter: string
  leave: string
  duration: number
}

interface TypeBasedTransitionProps {
  transitionType?: keyof typeof TYPE_MAP
}

const TYPE_MAP: Record<string, TransitionTypeDetails> = {
  fadeInOut: {
    enter: 'fadeIn',
    leave: 'fadeOut',
    duration: 300
  },
  fadeUpDown: {
    enter: 'fadeInUp',
    leave: 'fadeOutDown',
    duration: 300
  }
}

const TypeBasedTransition: FunctionalComponent<TypeBasedTransitionProps> = (props, { slots }) => {
  const enterClass =
    'animate__animated animate__' + TYPE_MAP[props.transitionType || 'fadeUpDown'].enter
  const leaveClass =
    'animate__animated animate__' + TYPE_MAP[props.transitionType || 'fadeUpDown'].leave

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const transitionProps = {
    name: 'type-based-transition',
    mode: 'out-in' as 'out-in' | 'in-out' | 'default',
    enterActiveClass: enterClass,
    leaveActiveClass: leaveClass,
    duration: TYPE_MAP[props.transitionType || 'fadeUpDown'].duration
  }

  return h(Transition, props, slots.default ? () => (slots.default ? slots.default() : []) : [])
}

export default TypeBasedTransition
